<template>
  <div class="ep-transfer">
    <slot name="select"></slot>
    <div class="ep-transfer__buttons">
      <div :class="['ep-tranfer_button',{'ep-tranfer_bactive':select.length>0}]" @click="confirm_controll('select')">
        <slot name="sbtn"></slot>
      </div>
      <div :class="['ep-tranfer_button',{'ep-tranfer_bactive':result.length>0}]" @click="confirm_controll('result')">
        <slot name="rbtn"></slot>
      </div>
    </div>
    <slot name="result"></slot>
  </div>
</template>

<script>
  import TransferPanel from './transfer-panel.vue'
  import unit from '../../../lib/unit'

  export default {
    name: 'ep-transfer',
    created() {
      this.bind_event()
    },
    data() {
      return {
        select: [],
        result: []
      }
    },
    mounted() {
      this.init_content()
    },
    mixins: [unit],
    methods: {
      init_content() {
        let btns = this.$el.getElementsByClassName('ep-tranfer_button')
        if (this.$slots.sbtn) return
        btns[0].innerHTML = '选中'
        if (this.$slots.rbtn) return
        btns[1].innerHTML = '移除'
      },
      // 监听子组件事件
      bind_event() {
        this.$on('select', (val, name) => {
          if (name == 'select') {
            this.select = JSON.parse(JSON.stringify(val))
          }
          if (name == 'result') {
            this.result = JSON.parse(JSON.stringify(val))
          }
        })
      },
      // 选中和移除操作
      confirm_controll(name) {
        if (name == 'select') {
          this.broadcast('ep-transfer-panel', 'controll', this.select, name)
        }
        if (name == 'result') {
          this.broadcast('ep-transfer-panel', 'controll', this.result, name)
        }
      }
    },
    components: {
      TransferPanel
    }
  }
</script>

<style scoped>
  .ep-transfer {
    width: 100%;
    height: auto;
    position: relative;
  }

  .ep-transfer__buttons {
    display: inline-block;
    vertical-align: middle;
    padding: 0 20px;
    font-size: 14px;
  }

  .ep-transfer__buttons>div:nth-of-type(1) {
    margin-bottom: 10px;
  }

  .ep-tranfer_button {
    height: 36px;
    width: 36px;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    border: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    color: #c0c4cc;
    cursor: no-drop;
    user-select: none;
    font-size: 12px;
  }

  .ep-tranfer_bactive {
    cursor: pointer;
    background-color: #409EFF;
    color: #fff;
  }

  .ep-tranfer_bactive:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
  }

  .ep-tranfer_bactive:active {
    background-color: #3a8ee6;
    border-color: #3a8ee6;
  }
</style>


// WEBPACK FOOTER //
// transfer.vue?02220d14